import React, { FC, useMemo, useState } from 'react';
import { withConfig } from 'common/providers/configProvider';
import { initialiseFiltersFromConfig } from 'menus/utils/filterHelpers';
import { MenuFiltersContext } from './MenuFiltersContext';

interface MenuFiltersProviderProps {
  config: GatsbyTypes.config;
}

const MenuFiltersProvider: FC<MenuFiltersProviderProps> = ({
  children,
  config: { allergenInformation, features },
}) => {
  const { allergens: allergenFiltersList } = allergenInformation;

  const [vegetarianFilter, setVegetarianFilter] = useState(false);
  const [veganFilter, setVeganFilter] = useState(false);
  const [allergenFilters, setAllergenFilters] = useState(
    initialiseFiltersFromConfig(allergenFiltersList)
  );
  const [potentialAllergensFilter, setPotentialAllergensFilter] = useState(
    features?.mayContainsEnabled
  );

  const contextValue = useMemo(() => {
    const selectedAllergenFilters = allergenFilters.filter((filter) => filter.isSelected === true);

    const selectedChildAllergenFilters = selectedAllergenFilters.map((filter) =>
      filter.subInformation.filter((subFilter) => subFilter.isSelected === true)
    );

    const hasNoFiltersSelected = () => {
      if (selectedAllergenFilters?.length === 0 && selectedChildAllergenFilters?.length === 0) {
        return true;
      }

      return false;
    };

    return {
      veganFilter,
      setVeganFilter,
      allergenFilters,
      vegetarianFilter,
      setAllergenFilters,
      setVegetarianFilter,
      selectedAllergenFilters,
      selectedChildAllergenFilters,
      selectedAllergens: [...selectedAllergenFilters, ...selectedChildAllergenFilters],
      hasNoFiltersSelected,
      potentialAllergensFilter,
      setPotentialAllergensFilter,
    };
  }, [allergenFilters, veganFilter, vegetarianFilter, potentialAllergensFilter]);

  return <MenuFiltersContext.Provider value={contextValue}>{children}</MenuFiltersContext.Provider>;
};

export default withConfig(MenuFiltersProvider);
